import type { PublicEvent } from '@arenapulse/shared';
import { EventCard } from './event-card';

interface EventListProps {
  events: PublicEvent[];
  isLoading: boolean;
  error: string | null;
  onDeleteClick: (event: PublicEvent) => void;
  onCreateClick: () => void;
  onOpenArena: (event: PublicEvent) => void;
}

export function EventList({ events, isLoading, error, onDeleteClick, onCreateClick, onOpenArena }: EventListProps) {
  if (isLoading) {
    return (
      <div className="py-12 text-center text-muted">
        Loading events...
      </div>
    );
  }

  if (error) {
    return (
      <div className="rounded-md bg-surface border border-destructive p-4 my-6">
        <div className="text-sm text-destructive">{error}</div>
      </div>
    );
  }

  if (events.length === 0) {
    return (
      <div className="text-center py-16 bg-surface border border-border rounded-lg border-dashed">
        <svg
          className="mx-auto h-12 w-12 text-muted"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
          />
        </svg>
        <h3 className="mt-2 text-sm font-semibold text-foreground">No events</h3>
        <p className="mt-1 text-sm text-muted">Create your first event to get started.</p>
        <div className="mt-6">
          <button
            type="button"
            onClick={onCreateClick}
            className="inline-flex items-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-primary-foreground shadow-sm hover:bg-muted focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
          >
            Create Event
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {events.map((event) => (
        <EventCard key={event.id} event={event} onDeleteClick={onDeleteClick} onOpenArena={onOpenArena} />
      ))}
    </div>
  );
}
